import { render } from "./CardOpcoesAlertas.vue?vue&type=template&id=2c40855b"
import script from "./CardOpcoesAlertas.vue?vue&type=script&lang=js"
export * from "./CardOpcoesAlertas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__